import type { Components } from '@mui/material/styles';

import type { Theme } from '../types';

export const MuiButton = {
  styleOverrides: {
    root: ({ theme }) => {
      const isDark = theme.palette.mode === 'dark';
      return {
        borderRadius: '12px',
        textTransform: 'none',
        fontWeight: 500,
        transition:
          'background-color 180ms ease, color 180ms ease, border-color 180ms ease, box-shadow 180ms ease, transform 120ms ease',
        '&:focus-visible': {
          outline: 'none',
          boxShadow: `0 0 0 3px ${
            isDark ? 'rgba(99, 91, 255, 0.4)' : 'rgba(99, 91, 255, 0.25)'
          }`,
        },
        '&.Mui-disabled': {
          opacity: 0.55,
        },
      };
    },
    contained: ({ theme }) => {
      const isDark = theme.palette.mode === 'dark';
      return {
        boxShadow: isDark
          ? '0 1px 2px rgba(0, 0, 0, 0.45)'
          : '0 1px 2px rgba(16, 24, 40, 0.06)',
        '&:hover': {
          boxShadow: isDark
            ? '0 4px 14px rgba(0, 0, 0, 0.55)'
            : '0 4px 14px rgba(16, 24, 40, 0.12)',
        },
        '&:active': {
          transform: 'translateY(1px)',
          boxShadow: 'none',
        },
      };
    },
    outlined: ({ theme }) => {
      const isDark = theme.palette.mode === 'dark';
      return {
        borderColor: isDark ? 'rgba(255, 255, 255, 0.16)' : 'rgba(16, 24, 40, 0.16)',
        '&:hover': {
          borderColor: isDark ? 'rgba(255, 255, 255, 0.28)' : 'rgba(16, 24, 40, 0.28)',
          backgroundColor: isDark ? 'rgba(255, 255, 255, 0.04)' : 'rgba(16, 24, 40, 0.04)',
        },
      };
    },
    text: ({ theme }) => {
      const isDark = theme.palette.mode === 'dark';
      return {
        '&:hover': {
          backgroundColor: isDark ? 'rgba(255, 255, 255, 0.05)' : 'rgba(16, 24, 40, 0.04)',
        },
      };
    },
    sizeSmall: { padding: '6px 16px' },
    sizeMedium: { padding: '8px 20px' },
    sizeLarge: { padding: '11px 24px' },
    textSizeSmall: { padding: '7px 12px' },
    textSizeMedium: { padding: '9px 16px' },
    textSizeLarge: { padding: '12px 16px' },
  },
} satisfies Components<Theme>['MuiButton'];
